
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "8 conseils pour gérer le budget de vos campagnes SEA",
    description:
      "ALEO vous apprend à créer et gérer un budget efficace pour vos campagnes SEA. Optimisez vos dépenses et maximisez votre ROI grâce à nos conseils pratiques.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
